if (!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();
      this.classPrefix = this.dataset.class;
      this.popupTriggers = this.querySelectorAll(`.${this.classPrefix}__popup-trigger`);
      this.popupTargets = this.querySelectorAll(`.${this.classPrefix}__popup-target`);
    }
    connectedCallback(){
      this.popupTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const selector = [
            `.${this.classPrefix}__price-badge-sale`,
            `.${this.classPrefix}__price-badge-sale-icon`,
            `.${this.classPrefix}__price-badge-info-icon`
          ].join(', ');
          let isValid = false;
          if (event.target === trigger || event.target.closest(selector)) {
            isValid = true;
          }
          if (isValid) this.togglePopup(trigger);
        });

        const closeBtn = trigger.querySelector(`.${this.classPrefix}__popup-target .${this.classPrefix}__popup-close`);
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.closePopup(trigger);
          });
        }
      });
    }
    togglePopup(trigger){
      if (!trigger){
        return;
      }
      const target = trigger.querySelector(`.${this.classPrefix}__popup-target`);
      if (!target){
        return;
      }
      if(!target.classList.contains('active')){
        this.popupTargets.forEach((popup)=>{
          popup.classList.remove('active');
        });
      }
      target.classList.toggle('active');
    }
    closePopup(trigger){
      if (!trigger){
        return;
      }
      const target = trigger.querySelector(`.${this.classPrefix}__popup-target`);
      if (!target){
        return;
      }
      target.classList.remove('active');
    }
  }

  customElements.define('product-price', ProductPrice);
}
